import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomDatePicker from "../../../components/CustomDatePicker";
import CustomNumberInput from "../../../components/CustomNumberInput";
import { WithholdingService } from "../../../services/WithholdingService";
import { AddWithholdingRequest } from "../../../models/request/withholding/AddWithholdingRequest";
import CustomTextInput from "../../../components/CustomTextInput";
import { AddWithholdingResponse } from "../../../models/response/withholding/AddWithholdingResponse";
import { GetWithholdingByIdResponse } from "../../../models/response/withholding/GetWithholdingByIdResponse";

const WithholdingAdd = () => {
    const navigate = useNavigate();
    const pageName = "Ön Muhasebe > Tanımlamalar > Tevkifat Türü Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [withholdingId, setWithholdingId] = useState<string | undefined>(undefined);
    const [startDate, setStartDate] = useState<string | undefined>(undefined);
    const [endDate, setEndDate] = useState<string | undefined>(undefined);
    const [selectedWithholdingRate, setSelectedWithholdingRate] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [lowerLimitVatIncluded, setLowerLimitVatIncluded] = useState<string | undefined>(undefined);
    const [description, setDescription] = useState<string | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetWithholdingByIdResponse = await WithholdingService.getWithholdingById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setWithholdingId(response.data.withholdingId);
                setStartDate(response.data.startDate);
                setEndDate(response.data.endDate);

                if (response.data.withholdingRateId && response.data.withholdingRateName)
                    setSelectedWithholdingRate({ label: response.data.withholdingRateName, value: response.data.withholdingRateId });

                setLowerLimitVatIncluded(response.data.lowerLimitVatIncluded?.toString())
                setDescription(response.data.description);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveWithholding = async () => {
        try {
            if (Helpers.isEmpty(endDate) || Helpers.isEmpty(lowerLimitVatIncluded) || Helpers.isEmpty(startDate) || !selectedWithholdingRate) {
                toast.error('Lütfen boş alan bırakmayınız.');
                return;
            }

            dispatch(storeActivityIndicator(true));

            var obj: AddWithholdingRequest = {
                withholdingId: withholdingId,
                description: description,
                endDate: endDate,
                lowerLimitVatIncluded: lowerLimitVatIncluded,
                startDate: startDate,
                withholdingRateId: selectedWithholdingRate?.value
            }

            var response: AddWithholdingResponse = await WithholdingService.addWithholding(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomDatePicker isLabelRequired value={startDate} setValue={setStartDate} labelText="Başlangıç Tarihi" />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomDatePicker isLabelRequired value={endDate} setValue={setEndDate} labelText="Bitiş Tarihi" />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            isLabelRequired
                                            labelText="Oran"
                                            selectedValue={selectedWithholdingRate}
                                            onChange={setSelectedWithholdingRate}
                                            onMenuOpen={() => ConstantService.getConstantList('WITHHOLDING_RATE')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomNumberInput isLabelRequired value={lowerLimitVatIncluded} setValue={setLowerLimitVatIncluded} labelText="Alt Limit (KDV Dahil)" />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomTextInput value={description} setValue={setDescription} labelText="Açıklama" />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveWithholding}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default WithholdingAdd;